import dynamic from 'next/dynamic';
const Layout = dynamic(() => import('../hoc/staticLayout'), { loading: () => <></>, ssr: true });
const CommunityContent = dynamic(() => import('../components/static/communityPage/community'), { loading: () => <></>, ssr: true });
import { withRouter } from 'next/router'

function Community(props) {
  const meta = {
    title: "Community | Become part of the BAYAN community | Connect with Alumni & Students | Chat with a chaplain online | Bayan",
    description: "Become part of the BAYAN community, connect with Alumni & Students, chat with chaplain online or join the discussion with trending news and questions",
    route: "community",
  }
  return (
    <>
      <Layout theme={props.theme} meta={meta}>
        <CommunityContent router={props.router}/>
      </Layout>
    </>
  );
}

export default withRouter(Community);
